import React, { useState } from "react";
import "../assets/styles/main.css";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrency,
  setCurrency,
} from "../components/Redux/Slices/currencySlice";

import { useNavigate } from "react-router-dom";
import CountryFlag from "react-country-flag";
import InstallButtonPWA from "../components/InstallButtonPWA";

const Onboarding = () => {
  const [userName, setUserName] = useState(
    localStorage.getItem("username" || "")
  );
  const selectedCurrency = useSelector(selectCurrency);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currencyOptions = [
    { code: "Australian Dollar", label: "$", flag: "AU" },
    { code: "Brazilian Real", label: "R$", flag: "BR" },
    { code: "Canadian Dollar", label: "$", flag: "CA" },
    { code: "Swiss Franc", label: "CHF", flag: "CH" },
    { code: "Chinese Yuan", label: "¥", flag: "CN" },
    { code: "Euro", label: "€", flag: "EU" },
    { code: "British Pound", label: "£", flag: "GB" },
    { code: "Hong Kong Dollar", label: "$", flag: "HK" },
    { code: "Indian Rupee", label: "₹", flag: "IN" },
    { code: "Japanese Yen", label: "¥", flag: "JP" },
    { code: "South Korean Won", label: "₩", flag: "KR" },
    { code: "Mexican Peso", label: "$", flag: "MX" },
    { code: "Norwegian Krone", label: "kr", flag: "NO" },
    { code: "New Zealand Dollar", label: "$", flag: "NZ" },
    { code: "Russian Ruble", label: "₽", flag: "RU" },
    { code: "Saudi Riyal", label: "ر.س", flag: "SA" },
    { code: "Singapore Dollar", label: "$", flag: "SG" },
    { code: "Swedish Krona", label: "kr", flag: "SE" },
    { code: "Turkish Lira", label: "₺", flag: "TR" },
    { code: "US Dollar", label: "$", flag: "US" },
    { code: "South African Rand", label: "R", flag: "ZA" },
  ];

  const handleCurrencyChange = (currency) => {
    console.log("Selected Currency:", currency);
    dispatch(setCurrency(currency));
    localStorage.setItem("selectedCurrency", JSON.stringify(currency));
  };
  const handleContinue = (e) => {
    e.preventDefault();
    localStorage.setItem("onboardingShow", true);
    localStorage.setItem("username", userName);
    navigate("/");
  };

  return (
    <div className="container  p-2 pt-4 ">
      {/* <div className="display-center mb-4 ">
        <span className="  position-absolute end-0 ">
          <InstallButtonPWA />
        </span>
      </div> */}
      <div className="display-center mb-4">
        <img src="assets/images/App.png" alt="logo" height={100} />
      </div>
      <h4 className="heading-txt mb-4"> Welcome to the Expense Tracking App</h4>
      <div className=" child-div card ">
        <form onSubmit={handleContinue}>
          <div className="row pb-3 ">
            <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
              <label className="mb-3">Name *</label>
              <input
                type="text"
                className="text-size form-control"
                placeholder="Enter Your Name"
                value={userName || ""}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
              <label className="mb-3 ">Currency *</label>
              <Dropdown>
                <Dropdown.Toggle
                  className="button-div w-100 p-2 form-control display-between"
                  variant="light"
                  id="currency-dropdown "
                >
                  {selectedCurrency ? (
                    <>
                      <span>
                        <CountryFlag countryCode={selectedCurrency.flag} svg />
                        <span className="ms-2">
                          {selectedCurrency.code}
                          <span className="ms-1 currencyIcons">
                            {selectedCurrency.label}
                          </span>
                        </span>
                      </span>
                    </>
                  ) : (
                    "Select Currency"
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100 form-control ">
                  {currencyOptions.map((currency) => (
                    <Dropdown.Item
                      key={`${currency.code}`}
                      onClick={() => handleCurrencyChange(currency)}
                      active={selectedCurrency?.code === currency?.code}
                    >
                      <CountryFlag countryCode={currency.flag} svg />
                      <span className="ms-2 ">{currency?.code} </span>
                      {currency?.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>{" "}
            </div>
          </div>{" "}
          <div className=" display-center button-position  ">
            <div className="row gx-3 gy-3 ">
              <InstallButtonPWA
                userName={userName}
                buttonLabel="Continue & Install App"
              />{" "}
              <button
                type="submit"
                disabled={!userName}
                className={`btn btn-danger mb-2   rounded-pill noSpace ${
                  !userName ? "btn-disabled" : ""
                }`}
              >
                <span className="">
                  <span className="material-symbols-outlined verticalAlign me-2">
                    resume
                  </span>
                  <span className="verticalAlign  ">Continue</span>
                  {/* <span className="d-none d-md-block">In Browser</span> */}
                </span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Onboarding;
